// extracted by mini-css-extract-plugin
module.exports = {"tabela":"OpcoesTabela_tabela__1NI4P"};